"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftInfoBox = void 0;
const react_1 = __importDefault(require("react"));
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const format_hours_1 = require("@app/util/format-hours");
const maybe_1 = require("@app/util/functional/maybe");
const shift_context_1 = require("../shift-context");
const use_available_shift_sections_1 = require("../use-available-shift-sections");
const hasTotalMinutes = (t) => 'totalMinutes' in t && (0, util_1.isValue)(t.totalMinutes);
const hasOvertimeMinutes = (t) => 'overTimeTotalMinutes' in t && (0, util_1.isValue)(t.overTimeTotalMinutes);
const hasWorkMinutes = (t) => 'workMinutes' in t && (0, util_1.isValue)(t.workMinutes);
const ShiftInfoBox = () => {
    const { dummyShift, getValues, toggledSections } = (0, shift_context_1.useShift)();
    const { customAttributes, pausesFixed, user } = getValues();
    const sections = (0, use_available_shift_sections_1.useAvailableShiftSections)();
    const filteredCustomSections = sections.filter((sec) => toggledSections.some((_sec) => sec.id === _sec) &&
        sec.isCustomAttribute === true);
    const durationFields = customAttributes
        ?.filter((attribute) => {
        return (attribute.value &&
            filteredCustomSections.some((section) => {
                return (section.id === attribute.attributeId &&
                    section.attribute?.type === 'duration' &&
                    section.attribute.options?.countTowardsPeriod);
            }));
    })
        .map((attribute) => {
        const attributeType = filteredCustomSections.find((section) => section.isCustomAttribute && section.id === attribute.attributeId);
        // @ts-expect-error
        return `${attributeType.name}: ${(0, format_hours_1.formatHours)(attribute.value / 60)}`;
    }) || [];
    const durationAttributesText = durationFields.length
        ? ` ${(0, util_1.t)('FROM_THAT')} ${durationFields.join(', ')}`
        : '';
    const pauseMinutes = new maybe_1.Maybe(dummyShift?.pauses)
        .map((_pauses) => _pauses.filter(util_1.isValue))
        .map((_pauses) => _pauses.reduce((acc, curr) => acc + (curr.duration ?? 0), 0))
        .get(() => 0);
    const valueStats = new maybe_1.Maybe(dummyShift?.stats).map((_stats) => _stats.filter(util_1.isValue));
    const totalMinutes = valueStats
        .map((_stats) => _stats.filter(hasTotalMinutes))
        .map((_stats) => _stats.reduce((acc, curr) => acc + curr.totalMinutes, 0))
        .get(() => 0);
    const workMinutes = valueStats
        .map((_stats) => _stats.filter(hasWorkMinutes))
        .map((_stats) => _stats.reduce((acc, curr) => acc + curr.workMinutes, 0))
        .get(() => 0);
    const overtimeMinutes = valueStats
        .map((_stats) => _stats.filter(hasOvertimeMinutes))
        .map((_stats) => _stats.reduce((acc, curr) => acc + curr.overTimeTotalMinutes, 0))
        .get(() => 0);
    const overtimeText = overtimeMinutes > 0
        ? ` + ${(0, util_1.t)('OVERTIME')}: ${(0, format_hours_1.formatHours)(overtimeMinutes / 60)}`
        : '';
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            position: 'sticky',
            paddingTop: '0.5rem',
            paddingBottom: '0.25rem',
            top: '-1rem',
            zIndex: 10,
            background: 'white',
        } },
        react_1.default.createElement(ui_1.Alert, { style: {
                height: '3.25rem',
                width: '100%',
                paddingTop: '0.6rem',
                display: 'flex',
                alignItems: 'start',
            }, size: 'FULL_WIDTH' },
            react_1.default.createElement("div", { style: {
                    width: '100%',
                    height: 'calc(100% + 0.2rem)',
                    display: 'flex',
                    alignItems: 'start',
                    justifyContent: 'space-between',
                    paddingInline: '0.5rem',
                } },
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'start',
                        flexGrow: 0,
                        flexShrink: 1,
                    } },
                    react_1.default.createElement(ui_1.Text, { weight: 'medium', color: 'primary', type: 'body-large' }, `${(0, util_1.t)('WORK_TIME')}: ${(0, format_hours_1.formatHours)((workMinutes - overtimeMinutes) / 60)}${overtimeText}${durationAttributesText}`)),
                react_1.default.createElement("div", { style: {
                        flexGrow: 0,
                        flexShrink: 0,
                        justifyContent: 'end',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.25rem',
                    } },
                    react_1.default.createElement(ui_1.Text, { weight: 'medium', color: 'primary', type: 'body-large' },
                        (0, util_1.t)('MA_PAUSES') + ': ',
                        !pausesFixed && !user
                            ? (0, util_1.t)('ATTENDANCE_HOURS_LABEL.accordingToEmployee')
                            : (0, format_hours_1.formatHours)(pauseMinutes / 60)),
                    react_1.default.createElement(ui_1.Text, { weight: 'medium', color: 'primary', type: 'body-large' },
                        (0, util_1.t)('ATTENDANCE_HOURS_LABEL.atWork'),
                        ": ",
                        (0, format_hours_1.formatHours)(totalMinutes / 60)))))));
};
exports.ShiftInfoBox = ShiftInfoBox;
